<template>
    <div>
        <el-row class="search-add" :gutter="15">
            <el-col :span="2">
                <router-link to="./add">
                    <el-button type="success">新增</el-button>
                </router-link>
            </el-col>
        </el-row>

        <el-table :data="data" border stripe style="width: 100%">
            <af-table-column prop="name" label="app名称">
            </af-table-column>
            <af-table-column prop="version" label="版本号">
            </af-table-column>
            <af-table-column prop="description" label="描述">
            </af-table-column>
            <af-table-column fixed="right" label="操作" width="120">
                <template slot-scope="scope">
                    <el-button @click="Edit(scope.$index)" type="text" size="small">编辑</el-button>
                    <el-button @click="Delete(scope.$index)" type="text" size="small">删除</el-button>
                </template>
            </af-table-column>
        </el-table>
        <div class="tableDel-Page">
            <Pagination :params="pagin" @pageBind="getList"></Pagination>
        </div>
    </div>
</template>

<script>
    import Pagination from '@/components/Pagination';
    export default {
        data() {
            return {
                data: [],
                pagin: {
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                },
            }
        },
        methods: {
            search() {//搜索
                this.pagin.pageNum = 1;
                this.getList();
            },
            getList() {
                //数据绑定
                let params = {
                    page: this.pagin.pageNum,
                    limit: this.pagin.pageSize,
                }
                this.$http.get('/manage/app/list', {params:params}).then(results => {
                    this.data = results['data']['data']['records'];
                    this.pagin.total = results['data']['data']['total'];
                });
            },
            Delete(index) {
                //单删
                if(confirm('确认要删除吗？')) {
                    let version = this.data[index].version;
                    this.$http.post('/manage/app/delete',{version:version}).then(() => {
                        this.data.splice(index, 1);
                    })
                }
            },
            Edit(index) {
                this.$store.commit('setEditInfo',this.data[index]);
                this.$router.push('./edit/'+this.data[index].id);
            },
        },
        components: { Pagination }
    }
</script>